import {
    useContext,
    type FC
} from "react";
import {
    Platform,
    View
} from "react-native";
import type INavigationMenuGroupProps from "./type";
import stylesheet from "./stylesheet";
import {
    NavigationMenuLayoutContext,
    useNavigationMenuContext
} from "../../context";
import type {
    NavigationMenuTrackWebPropsType
} from "../../type";
import {
    NAVIGATION_MENU_TRACK_DATA_KEY
} from "../../util";
import PopoverSurface from "../../../popoverSurface";

const NavigationMenuGroup: FC<INavigationMenuGroupProps> = ({
    customTheme: customThemeProp,
    children,
    title,
    style
}) => {
    const context = useNavigationMenuContext({
        part: "Group"
    });

    const layout = useContext(NavigationMenuLayoutContext);

    const customTheme = customThemeProp ?? context?.customTheme;

    const webProps: NavigationMenuTrackWebPropsType = Platform.OS === "web" ? {
        dataSet: {
            [NAVIGATION_MENU_TRACK_DATA_KEY]: "true"
        }
    } : {};

    return <View
        {...webProps}
        style={[
            style,
            stylesheet.group,
            layout.isSheet ? stylesheet.sheetGroup : null
        ]}
    >
        <PopoverSurface.Group
            aria-label={layout.isSheet ? title : undefined}
            heading={layout.isSheet ? undefined : title}
            customTheme={customTheme}
        >
            <View
                style={stylesheet.links}
                role="list"
            >
                {children}
            </View>
        </PopoverSurface.Group>
    </View>;
};
export default NavigationMenuGroup;
